// Supabase clients. The operator client keeps a session; the public passport client never does (no cookie, no
// storage on the public route, PRD §9.6). Only the public URL and anonymous key reach the browser.
import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env } from '../env.ts';

function config(): { url: string; key: string } {
  if (!env.supabaseUrl || !env.supabaseAnonKey)
    throw new Error('VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set');
  return { url: env.supabaseUrl, key: env.supabaseAnonKey };
}

let operator: SupabaseClient | null = null;
export function operatorClient(): SupabaseClient {
  if (!operator) {
    const { url, key } = config();
    operator = createClient(url, key, { auth: { persistSession: true, autoRefreshToken: true } });
  }
  return operator;
}

export function publicClient(): SupabaseClient {
  const { url, key } = config();
  return createClient(url, key, {
    auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false, storage: undefined },
  });
}

export async function invoke<T>(fn: string, body: Record<string, unknown>): Promise<T> {
  const { data, error } = await operatorClient().functions.invoke(fn, { body });
  if (error) {
    let detail = '';
    try {
      const ctx = (error as { context?: Response }).context;
      if (ctx) detail = ((await ctx.json()) as { message?: string }).message ?? '';
    } catch {
      /* body not JSON */
    }
    throw new Error(detail || error.message);
  }
  return data as T;
}
